import React, { useState, useEffect } from "react";
import { Stack, Box, Typography, Grid, Button } from "@mui/material";
import Chart from "react-apexcharts";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomPageLoading from "../comman/CustomPageLoading";

import {
  GET_PROJECT_BROKER_HOUR_LIST,
  GET_CUSTOMER_BROKER_HOUR_LIST,
  GET_CUSTOMER_HEADER_STATISTICS_LIST,
  GET_PROJECT_HEADER_STATISTICS_LIST,
} from "../../constants/ApiRoute";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";
import NoRecordFound from "../comman/NoRecordFound";
import downloadIcon from "../../images/download-icon.svg";

export default function CustomerGraph(props) {
  const { customerTab, brokerTab, selectedBroker } = props;
  const navigate = useNavigate();

  let downloadFileName = 'Dashboard_Broker_Hour';

  console.log("selectedBrokerselectedBroker", selectedBroker)
  console.log("Broker Graph brokerData", brokerTab)

  if(brokerTab.customerId && brokerTab.projectId == ""){
    let customer = selectedBroker.customerDetails.find(customer => customer.CustomerID === brokerTab.customerId);
    downloadFileName = `${customer.CustomerName.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_')}_Dashboard_Broker_Hour`
  }

  if(brokerTab.projectId){
    let customer = selectedBroker.customerDetails.find(customer => customer?.CustomerID === brokerTab?.customerId);
    let project = customer?.projectDetails.find(project => project?.ProjectID === brokerTab?.projectId);
    downloadFileName = `${customer?.CustomerName.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_')}_${project?.ProjectName.replace(/ /g, '_')}_Dashboard_Broker_Hour`
  }

  const [customerHeaderStatistic, setCustomerHeaderStatistic] = useState({
    CustomerID: "",
    Name: "",
    DayRate: "",
    BillingPeriod: "",
    ProjectCount: "",
    BrokerCount: "",
    BillingCount: "",
    Active: "",
  });

  const [projectHeaderStatistic, setProjectHeaderStatistic] = useState({
    CustomerID: "",
    ProjectID: "",
    Name: "",
    Active: "",
    BillingPeriod: "",
    LocationCount: "",
    BrokerCount: "",
    BillingOpenCount: "",
    BillingClosedCount: "",
    BillingInvCount: "",
  });

  const [optionss, setOptionss] = useState({});
  const [seriess, setSeriess] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);

  const handleManageButton1 = () => {
    navigate(`/project-details/${brokerTab?.projectId}`);
    localStorage.setItem("DASHBOARD_NAVI", true);
  };

  const handleManageButton = () => {
    navigate(`/customer-details/${brokerTab?.customerId}`);
    localStorage.setItem("DASHBOARD_NAVI", true);
  };

  const handleManageButtonProjectRollUp = () => {
    //navigate(`/report-dashboard/${enCryptFun(JSON.stringify({ projectId: brokerTab.projectId }))}`);
    window.open(
      `/report-dashboard/${enCryptFun(
        JSON.stringify({ projectId: brokerTab.projectId })
      )}`,
      "_blank"
    ); // Opens the URL in a new tab
    localStorage.setItem("DASHBOARD_NAVI", true);
  };

  const getCusomerBrokerHourCount = async () => {
    setOptionss({});
    setSeriess([]);

    const config = {
      method: "GET",
      url: GET_CUSTOMER_BROKER_HOUR_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({ customerId: brokerTab.customerId })
        ),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const filteredCustomerBrokerDataArray = data.filter(function (item) {
          // return item.UserName !== null && item.TotalHours > 0;
          return item.UserName !== null;
        });

        const userNames = filteredCustomerBrokerDataArray.map(
          (item) => item.UserName
        );

        const numericTotalHours = filteredCustomerBrokerDataArray.map((item) =>
          item.TotalHours != null ? parseFloat(item.TotalHours).toFixed(2) : "0.00"
        );
        // var totalHours = filteredCustomerBrokerDataArray.map(
        //   (item) => item.TotalHours
        // );

        var option = {
          series: [
            {
              data: numericTotalHours?.map(Number),
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            toolbar: {
              show: true,
              tools: {
                download: `<div id="custom-download-icon" title="Download"><img src=${downloadIcon} /></div>`,
              },
              export: {
                png: {
                  filename: downloadFileName,
                }
              }
            },
            events: {
              click: function () {
                // Call your custom function when download is clicked
                customDownloadFunction();
              },
            },
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              borderRadiusApplication: "end",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val.toFixed(2); // Display values with two decimals
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val.toFixed(2); // Ensure tooltip shows two decimals
              },
            },
          },
          xaxis: {
            categories: userNames,
            title: {
              text: "Broker Hours", // Set the y-axis title
              style: {
                fontSize: "12px",
                fontWeight: "normal",
              },
            },
          },
        };
        setOptionss(option);

        setSeriess([
          {
            name: "Broker Hour",
            data: numericTotalHours?.map(Number),
          },
        ]);

        console.log("totalHours", totalHours);
        console.log("userNames", userNames);
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    } finally {
    }
  };

  const getProjectBrokerHourCount = async () => {
    setOptionss({});
    setSeriess([]);

    const config = {
      method: "GET",
      url: GET_PROJECT_BROKER_HOUR_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({ projectId: brokerTab.projectId })
        ),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const filteredCustomerBrokerDataArray = data.filter(function (item) {
          // return item.UserName !== null && item.TotalHours > 0;
          return item.UserName !== null;
        });

        const userNames = filteredCustomerBrokerDataArray.map(
          (item) => item.UserName
        );

        const numericTotalHours = filteredCustomerBrokerDataArray.map((item) =>
          item.TotalHours != null ? parseFloat(item.TotalHours).toFixed(2) : "0.00"
        );
        // var totalHours = filteredCustomerBrokerDataArray.map(
        //   (item) => item.TotalHours
        // );

        var option = {
          series: [
            {
              data: numericTotalHours?.map(Number),
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            toolbar: {
              show: true,
              tools: {
                download: `<div id="custom-download-icon" title="Download"><img src=${downloadIcon} /></div>`,
              },
              export: {
                png: {
                  filename: downloadFileName,
                }
              }
            },
            events: {
              click: function () {
                // Call your custom function when download is clicked
                customDownloadFunction();
              },
            },
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              borderRadiusApplication: "end",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
            formatter: function (val) {
              return val.toFixed(2); // Display values with two decimals
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val.toFixed(2); // Ensure tooltip shows two decimals
              },
            },
          },
          xaxis: {
            categories: userNames,
            title: {
              text: "Broker Hours", // Set the y-axis title
              style: {
                fontSize: "12px",
                fontWeight: "normal",
              },
            },
          },
        };
        setOptionss(option);

        setSeriess([
          {
            name: "Broker Hour",
            data: numericTotalHours?.map(Number),
          },
        ]);

        console.log("totalHours", totalHours);
        console.log("userNames", userNames);
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    } finally {
    }
  };

  const getProjectHeaderStatistics = async () => {
    const config = {
      method: "GET",
      url: GET_PROJECT_HEADER_STATISTICS_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({ projectId: brokerTab.projectId })
        ),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;

      console.log("parsedResponse project", parsedResponse);
      if (status === "Success") {
        if (data && data[0]) {
          setProjectHeaderStatistic(data[0]);
        }
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    } finally {
    }
  };

  const getCustomerHeaderStatistics = async () => {
    const config = {
      method: "GET",
      url: GET_CUSTOMER_HEADER_STATISTICS_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({ customerId: brokerTab.customerId })
        ),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        if (data && data[0]) {
          setCustomerHeaderStatistic(data[0]);
        }
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    } finally {
    }
  };

  const customDownloadFunction = () => {
    const svgItem = document.querySelector(".exportSVG");
    const csvItem = document.querySelector(".exportCSV");
    if (svgItem) svgItem.remove();
    if (csvItem) csvItem.remove();
  };

  // useEffect(() => {
  //   setPageLoading(true);
  //   getCustomerHeaderStatistics();
  //   getCusomerBrokerHourCount();
  //   setTimeout(() => {
  //     setPageLoading(false);
  //   }, 3000);
  // }, []);

  useEffect(() => {
    if (brokerTab.customerId && brokerTab.projectId == "") {
      setPageLoading(true);
      getCustomerHeaderStatistics();
      getCusomerBrokerHourCount();
      setTimeout(() => {
        setPageLoading(false);
      }, 3000);
    }
  }, [brokerTab]);

  useEffect(() => {
    if (brokerTab.projectId) {
      setPageLoading(true);
      getProjectBrokerHourCount();
      getProjectHeaderStatistics();
      setTimeout(() => {
        setPageLoading(false);
      }, 3000);
    }
  }, [brokerTab]);

  return (
    <>
      <Box
        className="bg-box user-log"
        sx={{ mt: "0px", mr: "9.5px", height: "99%" }}
      >
        <Stack
          sx={{ mb: "14px" }}
          direction={{ xs: "column", sm: "row", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "baseline", sm: "center" }}
        >
          {pageLoading ? <CustomPageLoading /> : ""}
          <Typography className="dashboard-title">
            {brokerTab.customerId && brokerTab.projectId == ""
              ? customerHeaderStatistic.Name
              : projectHeaderStatistic.Name}
          </Typography>
          <Grid sx={{ display: "flex", gap: "17px" }}>
            {brokerTab.projectId && (
              <Button
                sx={{ width: "max-content" }}
                className="reset-btn"
                onClick={handleManageButtonProjectRollUp}
              >
                Project Rollup
              </Button>
            )}
            {brokerTab?.customerId != "" && brokerTab.projectId == "" ? (
              <Button className="reset-btn" onClick={handleManageButton}>
                Manage
              </Button>
            ) : brokerTab?.customerId != "" && brokerTab.projectId != "" ? (
              <Button className="reset-btn" onClick={handleManageButton1}>
                Manage
              </Button>
            ) : (
              ""
            )}
          </Grid>
        </Stack>

        {/* Customer Card */}
{console.log('brokerTab',brokerTab)}
        {brokerTab.customerId && brokerTab.projectId == "" && (
          <Stack
            sx={{ mb: "28px" }}
            className="broker-count-box"
            direction={{ xs: "column", sm: "row", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "baseline", sm: "center" }}
          >
            <Box>
              <Typography className="br-title">Active</Typography>
              <Typography className="br-text">
                {customerHeaderStatistic.Active ? "Yes" : "No"}
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Day Rate</Typography>
              <Typography className="br-text">
                {" "}
                $
                {customerHeaderStatistic.DayRate
                  ? customerHeaderStatistic.DayRate.toFixed(2)
                  : 0.0}
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Billing Period</Typography>
              <Typography className="br-text">
                {customerHeaderStatistic.BillingPeriod
                  ? customerHeaderStatistic.BillingPeriod
                  : 0}{" "}
                days
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Brokers</Typography>
              <Typography className="br-text">
                {customerHeaderStatistic.BrokerCount
                  ? customerHeaderStatistic.BrokerCount
                  : 0}{" "}
                assigned
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Projects</Typography>
              <Typography className="br-text">
                {customerHeaderStatistic.ProjectCount
                  ? customerHeaderStatistic.ProjectCount
                  : 0}{" "}
                active
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Billing Stmts</Typography>
              <Typography className="br-text">
                {customerHeaderStatistic.BillingCount
                  ? customerHeaderStatistic.BillingCount
                  : 0}{" "}
                open
              </Typography>
            </Box>
          </Stack>
        )}

        {/* Poject Card */}
        {brokerTab.customerId && brokerTab.projectId && (
          <Stack
            sx={{ mb: "28px" }}
            className="broker-count-box"
            direction={{ xs: "column", sm: "row", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "baseline", sm: "center" }}
          >
            <Box>
              <Typography className="br-title">Billing Periods</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.BillingPeriod
                  ? projectHeaderStatistic.BillingPeriod
                  : 0}{" "}
                days
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Locations</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.LocationCount
                  ? projectHeaderStatistic.LocationCount
                  : 0}{" "}
                locations
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Brokers</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.BrokerCount
                  ? projectHeaderStatistic.BrokerCount
                  : 0}{" "}
                brokers
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Open Stmts</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.BillingOpenCount
                  ? projectHeaderStatistic.BillingOpenCount
                  : 0}{" "}
                open
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Closed Stmts</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.BillingClosedCount
                  ? projectHeaderStatistic.BillingClosedCount
                  : 0}{" "}
                closed
              </Typography>
            </Box>
            <Box>
              <Typography className="br-title">Open Invoices</Typography>
              <Typography className="br-text">
                {projectHeaderStatistic.BillingInvCount
                  ? projectHeaderStatistic.BillingInvCount
                  : 0}{" "}
                open
              </Typography>
            </Box>
          </Stack>
        )}

        <Box className="chart">
          <div style={{ marginTop: "30px" }} className="app">
            <div className="row">
              {optionss && optionss.chart ? (
                <div className="responsive-chart">
                  <Chart
                    options={optionss}
                    series={seriess}
                    type="bar"
                    width="100%"
                    height="590"
                  />
                </div>
              ) : (
                // <Typography sx={{ textAlign: "center", margin: "3rem" }}>
                //   No Record Found
                // </Typography>
                <NoRecordFound />
              )}
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}
